import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import { Link } from 'react-router-dom';
import propTypes from 'prop-types';
import Swal from 'sweetalert2';
import lang from '../../lang';
import YearView from './YearViewCalendar';
import '../../styles/calendar.scss';
import { createFetch } from '../../utils';
const { URL_PREFIX } = window;

class Calendar extends React.Component {
    constructor() {
        super();
        this.state = {
            selectedYear: moment().year(),
            loading: false,
            flightInformation: [],
        };
        this.changeYear = this.changeYear.bind(this);
    }

    componentWillMount() {
        this.changeYear(moment().year());
    }

    async changeYear(year) {
        const { loading } = this.state;
        if (loading) return;
        this.setState({ selectedYear: year, loading: true });
        const { user } = this.props;
        try {
            const result = await createFetch({
                path: `ama/search-flight?start_date=${year}-02-01&end_date=${year}-12-31`,
                accessToken: user.accessToken,
                method: 'GET',
            });
            this.setState({ flightInformation: result.records, loading: false });
        } catch (error) {
            this.setState({ loading: false });
            Swal.fire({
                title: 'An error occured',
                text: error.message,
            });
        }
    }

    render() {
        const { selectedYear, loading, flightInformation } = this.state;
        const { user } = this.props;
        const yearAvailable = _.times(10, index => (moment().year() + (index - 1)));
        return (
            <div className="gems-calendar" id="gemsCalendarPage">
                <div className="col-lg-12">
                    <div className="col-lg-12">
                        <h1 className="text-left" style={{ fontSize: 40 }}>{lang.calendar.calendarTitle}</h1>
                    </div>
                    <div className="col-lg-12">
                        <div className="col-lg-7 col-md-6 col-sm-12 col-xs-12" style={{ paddingLeft: 0, paddingTop: 20 }}>
                            <p>{lang.calendar.description}</p>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12 col-xs-12 years" style={{ padding: 0 }}>
                            {
                                yearAvailable.map(year => (
                                    <Link
                                        to={`${URL_PREFIX}/app/calendar/${year}`}
                                        className={`btn-year text-center ${selectedYear === year ? 'active' : null}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.changeYear(year);
                                        }}
                                    >
                                        {selectedYear === year ? <i className="fa fa-circle" /> : null }
                                        <br />
                                        {year}
                                    </Link>
                                ))
                            }
                        </div>
                    </div>
                    <div className="clearfix" />
                </div>
                <div className="clearfix" />
                <p className="text-center">
                    {loading ? <i className="fa fa-circle-notch fa-spin fa-4x loading" /> : null}
                </p>
                <YearView year={selectedYear} language={user.language} flightInformation={flightInformation} />
            </div>
        );
    }
}

Calendar.propTypes = {
    user: propTypes.object.isRequired,
};

Calendar.defaultProps = {
    // selectedYear: moment().year(),
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
});


export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
